import { library } from '@fortawesome/fontawesome-svg-core';
import {
  faCircleNotch,
  faTruckMedical,
  faUserNurse,
  faLocationDot,
  faPlus,
  faMinus,
  faUser,
  faTimes,
  faSquarePlus,
  faComment,
  faCheck,
  faTrash
} from '@fortawesome/free-solid-svg-icons';

library.add(faPlus);
library.add(faMinus);
library.add(faLocationDot);
library.add(faCircleNotch);
library.add(faTruckMedical);
library.add(faUserNurse);
library.add(faUser);
library.add(faTimes);
library.add(faSquarePlus);
library.add(faComment);
library.add(faCheck);
library.add(faTrash);
